import { Navigate } from 'react-router-dom';

import { PUBLIC, PRIVATE } from 'router/constants/routes';

import { useSelector } from 'react-redux';
import { isAuthenticatedSelector, isAuthenticationCompleteSelector } from 'store/auth/selectors';

const RootRedirect = () => {
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const isComplete = useSelector(isAuthenticationCompleteSelector);

    return <Navigate replace to={isComplete && isAuthenticated ? PRIVATE.MAIN.path : PUBLIC.LOGIN.path} />;
};

export default RootRedirect;
